import styles from "./style.module.scss";

// styled components
import { StyledAccordion } from "@ui/StyledAccordion";

// components
import Video from "@components/Video";
import StickyFilterBar from "@ui/StickyFilterBar";
import Spring from "@components/Spring";
import NothingFound from "@components/NothingFound";

// hooks
import { useWindowSize } from "react-use";
import { Details, Summary } from "@layout/help/QuestionsList/style";
import classNames from "classnames";
import { useState } from "react";
import GradientBtn from "@ui/GradientBtn";

const FAQQuestions = ({ data }) => {
  const [showAll, setShowAll] = useState(false);
  const isTablet = useWindowSize().width < 1170;

  // Adjust the number of questions to show initially
  const initialQuestionsToShow = 5;
  const visibleQuestions = showAll
    ? data
    : data?.slice(0, initialQuestionsToShow);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="section">
      <h1 className={styles.heading}>Frequently Asked Questions</h1>
      <div
        className={classNames(`${styles.container} container`, {
          "align-items-center": data.length === 0,
        })}
      >
        <div id="faq">
          {visibleQuestions?.map((item, index) => (
            <Spring
              className="border-bottom"
              key={`accordion${index}`}
              index={index}
            >
              <StyledAccordion>
                <Summary
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <h5 className="title">{item.question}</h5>
                  <i className="icon icon-angle-down text-light" />
                </Summary>
                <Details>
                  {/* Render answer content based on layout */}
                  {item.layout.map((block, index) => {
                    const { text, video, list } = item.answer;

                    switch (block) {
                      case "list":
                        return (
                          <ul
                            className="list d-flex flex-column g-5"
                            key={`list${index}`}
                          >
                            {list.map((item, index) => (
                              <li
                                className="list-item"
                                key={`listItem${index}`}
                              >
                                <span className="marker text-accent">
                                  {index + 1}.
                                </span>
                                {item}
                              </li>
                            ))}
                          </ul>
                        );
                      case "video":
                        return (
                          <Video
                            key={`video${index}`}
                            cover={video.cover}
                            id={video.id}
                          />
                        );
                      default:
                      case "text":
                        // Check if text is an array
                        if (Array.isArray(text)) {
                          // If it's an array, map over each paragraph
                          return text.map((paragraph, idx) => (
                            <p key={`text${index}-${idx}`} className="text">
                              {paragraph}
                            </p>
                          ));
                        } else {
                          // Otherwise, render text as a single paragraph
                          return (
                            <p key={`text${index}`} className="text">
                              {text}
                            </p>
                          );
                        }
                    }
                  })}
                </Details>
              </StyledAccordion>
            </Spring>
          ))}
          {/* Render 'See More' button if not all questions are shown */}
          {!showAll && data.length > initialQuestionsToShow && (
            <GradientBtn
              className={`${styles.button} `}
              onClick={toggleShowAll}
            >
              See More
            </GradientBtn>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQQuestions;
